export const OTP_VERIFIED = 'otp_verified';
export const SIGNUP = 'sign_up';
export const SIGN_UP_START = 'sign_up_start';
export const SIGNIN = 'sign_in';
export const REFER_EARN = 'refer_earn';
export const REFFERAL_SHARE = 'referral_share';
export const REFFERAL_SHARE_CT = 'referralShare';
export const REFFERAL_COPY = 'copy_link';
export const REFFERAL_QR = 'qr_link';
export const REFFERAL_MAIL = 'gmail_link';
export const SEND_MONEY = 'send_money';
export const PARAMETER_CHANGE = {
  SOURCE_AMOUNT_CHANGE: 'source_amount_change',
  SOURCE_CURRENCY_CHANGE: 'source_currency_change',
  DESTINATION_CURRENCY_CHANGE: 'destination_currency_change',
  DESTINATION_AMOUNT_CHANGE: 'destination_amount_change'
};
export const SESSION_TIMEOUT = 'session_timeout';
export const PAYMENT_METHOD_SELECTED = 'payment_method_selected';
export const PORFILE_SECTION_HELP_CENTER = 'profile_section_help_centre';
export const PROFILE_UPDATED = 'profile_updated';
export const PASSWORD_PROFILE = 'password_profile';
export const PASSWORD_PROFILE_UPDATED = 'password_profile_updated';
export const FEEDBACK_EVENT = 'feedback';
export const TIMELINE_PAYIN = 'timeline_payin_tap';
export const TIMELINE_PAYOUT = 'timeline_payout_tap';
export const PERSONAL_DETAILS = 'personal_details';
export const PERSONAL_INFORMATION_PAGE = 'personal_information_page';
export const VERIFF_START_PAGE = 'veriff_start_page';
//TroubleShoot Login Event
export const TROUBLE_LOGGING_IN = 'trouble_logging_in';
export const PASSWORD_RESET = 'password_reset';
export const OTP_NOT_RECEIVED = 'otp_not_received';
export const OTHERS_LOGGING_IN = 'others_logging_in';

export const FLOW_TYPE_ONBOARDING = 'Onboarding';
export const FLOW_TYPE_PROFILE = 'Profile';
export const FLOW_TYPE_SEND_MONEY = 'Send Money';
export const FLOW_TYPE_LOGIN = 'Login';
export const FLOW_TYPE_REFER = 'Refer';
export const FLOW_TYPE_DASHBOARD = 'dashboard';
export const FLOW_TYPE_INSTAPOINT = 'Instapoint';
export const COUNTRY_REFERRAL_CODE_SELECTED = 'country_referral_code_selected';
export const SSN = 'ssn';
export const FLOW_TYPE_TROUBLE_LOGGING_IN = 'Trouble Logging In';
export const FLOW_TYPE_TRANSACTION = 'Transaction';
export const FLOW_TYPE_LOGOUT = 'Logout';

export const RUN_TIME_ERROR = 'run_time_error';

export const IpEventProperties = {
  page_name_ip_dashboardMenu: 'ip_dashboardMenu',
  page_name_ip_dashboard: 'ip_dashboard',
  transfer: 'transfer'
};
export const COUNTRY_ONB_DONE = 'country_onb_done';
export const TERMS_AND_CONDITIONS_FILLED = 't_and_c_filled';
export const REFERRAL_CODE_FILLED = 'referral_code_filled';
export const TRANSACTION_AUTHORIZATION_STARTED = 'transaction_authorization_started';
export const SIGN_UP_PAGE_VIEWED = 'sign_up_page_viewed';
export const BENEFICIARY_EDITED = 'beneficiary_edited';
export const AMAZE_GET_AMAZE = 'amaze_getamaze';
export const KYC_METHOD_SELECTED = 'kyc_method selected';
export const SING_PASS_KYC = 'singpass';
export const ADHAR_KYC = 'aadhar';
export const MANUAL_KYC = 'manual';
export const PERSONAL_DETAILS_FILLED = 'personal_details_filled';
export const ID_VERIFICATION_STARTED = 'id_verification_started';
export const JUMIO_KYC = 'jumio';
export const ONFIDO_KYC = 'onfido';
export const RECIPIENT_UPDATED = 'recipient_updated';
export const MANUAL_ENTRY_SELECTED = 'manual_entry_selected';
export const MOBILE_NUMBER = 'mobile_number';
export const MOBILE_NUMBER_FILLED = 'mobile_number_filled';
export const NF_MOBILE_NUMBER_FILLED = 'NF_mobile_number_filled';
export const OTP_PAGE = 'otp_page';
export const STORE_REVIEW = 'store_review_clicked';
export const UPSELLING_POPUP_SHOWN = 'upselling_popup_shown';
export const UPSELLING_TRANSACTION_INITIATED = 'upselling_transaction_initiated';
export const ADDRESS_PAGE = 'address_page';
export const ADDRESS_DETAILS_FILLED = 'address_details_filled';
export const EMPLOYMENT_INFO_PAGE = 'employment_info_page';
export const EMPLOYMENT_DETAILS_FILLED = 'employment_details_filled';
export const EKYC_SERVICE_DOWN_PAGE = 'EKYC_SERVICE_DOWN_PAGE';
export const EKYC_COMPLETED_PAGE = 'EKYC_COMPLETED_PAGE';
export const VISA_SUBMITTED = 'visa_submitted';
export const ID_DOC_UPLOAD_COMPLETED = 'id_doc_upload_completed';
export const VISA_DETAILS_INITIATED = `visa_details_initiated`;
export const VISA_STATUS_AWAITED = `visa_status_awaited`;
export const GO_TO_HOME_FROM_ONB = 'go_to_home_from_onb';
export const SEND_MONEY_INITIATED = 'send_money_initiated';
export const EVERIFICATION_SUCCESS = 'everification_success';
export const E_KYC_ATTEMPTED = 'ekyc_attempted';
export const ACCOUNT_USAGE_DETAILS_FILLED = 'account_usage_details_filled';
export const REGISTRATION_COMPLETED = 'registration_completed';
export const ACKNOWLEDGEMENT_PAGE = 'acknowledgement_page';
export const NF_UPLOADDOCS = 'NF_upload_docs';
export const NF_UPLOADDOCS_CT = 'NF_UploadDocs';
export const NF_PASSPORT_UPLOAD = 'NF_passport_upload';
export const NF_PASSPORT_UPLOAD_CT = 'NF_PassportUpload';
export const NF_REPEATFEMA = 'NF_repeat_fema';
export const NF_REPEATFEMA_CT = 'NF_RepeatFEMA';
export const NF_NEWFEMA = 'NF_new_fema';
export const NF_NEWFEMA_CT = 'NF_newFEMA';
export const NF_vKYC = 'NF_vkyc';

export const FTT_APAC_TRANSFER_NOW = 'FTT_APAC_TransferNow';
export const ADD_RECIPIENT = 'add_recipient';
export const NF_PAN_EVENT = 'NF_pan';
export const NF_SELECT_BANK_EVENT = 'NF_selection_bank';
export const NF_GO_TO_HOME_EVENT_CT = 'NF_gotoHome';
export const NF_AADHAR_EVENT = 'NF_aadhar_initiated';
export const NF_ESIGNIN_EVENT = 'NF_e_sign_in';
export const NF_PAYMENT_CALCULATOR_EVENT_CT = 'NF_PaymentCalculatorEvent';
export const NF_PAYMENT_COUPON_EVENT = 'NF_payment_coupon_event';
export const NF_AUTHORISE_TRANSACTION = 'NF_authorise_transaction';
export const NF_REUSE_KYC_EVENT = 'NF_reuse_kyc';
export const NF_REUSE_KYC_EVENT_CT = 'NF_ReuseKYC';
export const NF_REDO_KYC_EVENT = 'NF_redo_kyc';
export const NF_VIDEO_KYC_CT = 'NF_StartVideoKYC';
export const COMPARE_TABLE = 'compare_table';
export const COMPARE_TABLE_CT = 'compareTable';
export const SSN_VERIFICATION_PAGE = 'ssn_verification_page';
export const SSN_VERIFICATION_START = 'SSN_verification_start';
export const POP_UP_SSN = 'POP_up_ssn';
export const SSN_SUBMIT_CT = 'ssnSubmit';
export const PII_DETAILS_EDIT_CT = 'piiDetailsEdit';
export const HC_SEARCH_EVENT = 'hcSearchEvent';

export const FLOW_TYPE_HELP_CENTER = 'Help Center';
export const HC_BROWSE_EVENT = 'hcBrowseEvent';
export const FLOW_TYPE_RATE_COMPARE_TABLE = 'Rate Compare Table';
